import Repository from '@/api/Repository';

export default {

  getConfiguration(token) {
    return Repository.get('/configuration', {
      headers: {
        Authorization: token,
      },
    })
      .then(response => response.data);
  },
  saveConfiguration(token, payload) {
    return Repository.post('/configuration', payload, {
      headers: {
        Authorization: token,
      },
    });
  },
  sendMessage(token, payload) {
    return Repository.post('/myaccount/sendrequest', payload, {
      headers: {
        Authorization: token,
      },
    });
  },
  requestSubjects(token) {
    return Repository.get('/myaccount/requestsubjects',
      {
        headers:
          { Authorization: token },
      })
      .then(response => response.data);
  },
  baseConfig() {
    return {
      backendConfig: {
        CONTACT_HTML: '[{ "id": "de", "value": "<p>kontakt</p>"},{ "id": "en", "value": ""},{ "id": "pl", "value": "<p>test234567</p>"}]',
        CSS_FILE:
          {
            menuBackgroundStart: { value: '#005fab', default: '#005fab' },
            menuBackgroundEnd: { value: '#002678', default: '#002678' },
            menuHighlight: { value: '#fff', default: '#fff' },
            chartPrimaryColor: { value: '#005fab', default: '#005fab' },
            chartSecondaryColor: { value: '#002678', default: '#002678' },
            submitButton: { value: '#005fab', default: '#005fab' },
            cancelButton: { value: '#002678', default: '#002678' },
            fontColor: { value: '#878a94', default: '#878a94' },
            actionLinkColors: { value: '#005fab', default: '#005fab' },
            menuItemBackground: { value: '#000', default: '#000' },
          },
        CSV_DELIMITER: ';',
        LOGO_FILE: 'http://eye-js.dri7.vobacom.pl/logo.png',
        MAINTANACE_MAILING_LIST: '',
        MAINTANACE_MAILING_SUBJECTS: '',
        SHOP_IMAGE_FORMAT: 'png',
        SHOP_IMAGE_RESOURCE_PATH: 'file:/home/macp/',
        TOKEN_DURATION: '10000000',
      },
    };
  },
};
